<template>
    <div class="page">
        <v-container :class="{'px-0': phoneOnly}">
            <v-card :flat="phoneOnly" class="px-3 px-md-0" :class="{'transparent': phoneOnly, 'soft-shadow': pcOnly}" style="min-height: 50vh; max-width: 900px">

                <div v-if="loading">
                    <v-progress-circular indeterminate transition="fade-transition" color="primary" size="36" width="3"></v-progress-circular>
                </div>
                <v-list v-else-if="notifications && notifications.length" class="pa-0">
                        <div class="notifications-wrapper">
                            <div v-for="notification in notifications" :key="notification.id" class="notification-wrapper">
                                <notification :notification="notification" class="bordered mb-4 rounded" />
                            </div>
                        </div>

                        <div v-if="nextUrl" class="d-flex justify-center align-center mt-2 mb-4">
                            <v-btn text  color="primary darken-2" @click="loadData(true)" style="text-transform: capitalize;;">load more...</v-btn>
                        </div>
                </v-list>
                <div v-else :key="1" class="my-2">
                    <v-alert type="info" color="muted" text class="d-flex">
                        <div class="strong-text--text">You don't have notifications...</div>
                    </v-alert>
                </div>
            </v-card>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Notification from '@/components/default/notification'

export default {
  name: "notifications",
  components: {
    Notification
  },
  data(){
      return {
          loading: false,
          notifications: null,
          nextUrl: null,
      }
  },
  computed: {
      ...GlobalComputed
  },
  methods: {
        ...GlobalMethods,
        markAllAsRead(){
            if (this.user.notifications_count > 0){
                this.$store.dispatch('markAllAsRead');
            }
        },
        loadData(next=false){
            if (!this.loading){
                if (!next) this.loading = true;
                const url = next ? this.nextUrl : '/notifications';
                this.$store.dispatch('fastGetAction', {url}).then((response)=>{
                    if (next){
                        this.notifications.push(...response.data.data);
                    }else{
                        this.notifications = response.data.data;
                        this.markAllAsRead();
                    }
                    this.nextUrl  = response.data.links.next;
                    console.log(this.nextUrl);
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
  },
  mounted(){
    this.loadData();
  }
};
</script>
